import _classCallCheck from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
import * as React from 'react';
import withIntl, { Provider } from './injectIntl';
import { createError, filterProps, DEFAULT_INTL_CONFIG, createDefaultFormatters } from '../utils';
import { formatters } from '../format';
import areIntlLocalesSupported from 'intl-locales-supported';

var shallowEquals = require('shallow-equal/objects');

var intlConfigPropNames = ['locale', 'timeZone', 'formats', 'messages', 'textComponent', 'defaultLocale', 'defaultFormats', 'onError'];

function getConfig(filteredProps) {
  var config = Object.assign({}, DEFAULT_INTL_CONFIG, filteredProps); // Apply default props. This must be applied last after the props have
  // been resolved and inherited from any <IntlProvider> in the ancestry.
  // This matches how React resolves `defaultProps`.

  for (var propName in DEFAULT_INTL_CONFIG) {
    if (config[propName] === undefined) {
      config[propName] = DEFAULT_INTL_CONFIG[propName];
    }
  }

  if (!config.locale || !areIntlLocalesSupported(config.locale)) {
    var _config = config,
        locale = _config.locale,
        defaultLocale = _config.defaultLocale,
        defaultFormats = _config.defaultFormats,
        onError = _config.onError;
    if (typeof onError === 'function') onError(createError("Missing locale data for locale: \"".concat(locale, "\". ") + "Using default locale: \"".concat(defaultLocale, "\" as fallback."))); // Since there's no registered locale data for `locale`, this will
    // fallback to the `defaultLocale` to make sure things can render.
    // The `messages` are overridden to the `defaultProps` empty object
    // to maintain referential equality across re-renders. It's assumed
    // each <FormattedMessage> contains a `defaultMessage` prop.

    config = Object.assign({}, config, {
      locale: defaultLocale,
      formats: defaultFormats,
      messages: DEFAULT_INTL_CONFIG.messages
    });
  }

  return config;
} // Public primarily for testing


export function getBoundFormatFns(config, formatterFns) {
  return {
    formatNumber: formatters.formatNumber.bind(undefined, config, formatterFns),
    formatRelativeTime: formatters.formatRelativeTime.bind(undefined, config, formatterFns),
    formatDate: formatters.formatDate.bind(undefined, config, formatterFns),
    formatTime: formatters.formatTime.bind(undefined, config, formatterFns),
    formatPlural: formatters.formatPlural.bind(undefined, config, formatterFns),
    formatMessage: formatters.formatMessage.bind(undefined, config, formatterFns),
    formatHTMLMessage: formatters.formatHTMLMessage.bind(undefined, config, formatterFns)
  };
}

var IntlProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IntlProvider, _React$PureComponent);

  function IntlProvider(props) {
    var _this;

    _classCallCheck(this, IntlProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IntlProvider).call(this, props));
    var intlContext = props.intl; // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === void 0 ? createDefaultFormatters() : _ref$formatters;

    _this.state = {
      context: Object.assign({}, intlContext, {
        formatters: formatters
      })
    };
    return _this;
  }

  _createClass(IntlProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(Provider, {
        value: this.state.context
      }, this.props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var intlContext = nextProps.intl; // Build a whitelisted config object from `props`, defaults, and
      // `props.intl`, if an <IntlProvider> exists in the ancestry.

      var filteredProps = filterProps(nextProps, intlConfigPropNames, intlContext || {});

      if (!shallowEquals(filteredProps, prevState.filteredProps)) {
        var config = getConfig(filteredProps);
        var boundFormatFns = getBoundFormatFns(config, Object.assign({}, prevState.context.formatters));
        return {
          filteredProps: filteredProps,
          context: Object.assign({}, prevState.context, config, boundFormatFns)
        };
      }

      return null;
    }
  }]);

  return IntlProvider;
}(React.PureComponent);

export default withIntl(IntlProvider, {
  enforceContext: false
}); // to be able to inherit values from parent providers